import { render, staticRenderFns } from "./CustomChatNotification.vue?vue&type=template&id=52035736&scoped=true&"
import script from "./CustomChatNotification.vue?vue&type=script&lang=js&"
export * from "./CustomChatNotification.vue?vue&type=script&lang=js&"
import style0 from "./CustomChatNotification.vue?vue&type=style&index=0&id=52035736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52035736",
  null
  
)

export default component.exports